export default vm => {
    return vm.profile.customerId
        ? vm.$msgsDataProvider
            .get('permissions')
            .then(({ permissions }) => permissions)
            .catch(() => [])
        : Promise.resolve([]);
};
